import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AButton } from "@/components/ios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated");
      setTimeout(() => nav("/login"), 1500);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6" style={{ background: "var(--bg)" }}>
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <div className="h-12 w-12 rounded-2xl grid place-items-center mb-4" style={{ background: "var(--accent-soft)" }}>
          <ShieldCheck size={24} className="accent-text" />
        </div>
        <h1 className="text-2xl font-bold tracking-tight" style={{ color: "var(--text)" }}>Reset password</h1>
        {!token ? (
          <p className="text-sm text-secondary mt-2">This reset link is missing its token. <Link to="/login" className="accent-text">Back to sign in</Link>.</p>
        ) : done ? (
          <p className="text-sm text-secondary mt-2">Password updated. Redirecting to sign in…</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="New password (min 8 chars)" className="w-full rounded-xl px-4 py-3 text-sm outline-none border"
              style={{ background: "var(--surface)", borderColor: "var(--border)", color: "var(--text)" }} />
            {err && <div className="text-sm" style={{ color: "var(--danger)" }}>{err}</div>}
            <AButton testid="reset-submit" type="submit" className="w-full !py-3" disabled={password.length < 8}>Update password</AButton>
          </form>
        )}
      </motion.div>
    </div>
  );
}
